import React from 'react';
import { ShieldRounded } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import LegalDocument from '../components/LegalDocument';
import PublicPageLayout from '../components/PublicPageLayout';

const PrivacyPolicy = () => {
  const { i18n, t } = useTranslation();
  const settings = useSelector((state) => state.settingsdata.settings);
  const isRTL = i18n.dir() === 'rtl';

  return (
    <PublicPageLayout
      contentMaxWidth="md"
      eyebrow={t('legal_and_privacy', { defaultValue: 'Legal and privacy' })}
      icon={<ShieldRounded sx={{ fontSize: 23 }} />}
      subtitle={t('privacy_page_subtitle', {
        defaultValue: 'A clear overview of how information is handled when you use Laiwani.'
      })}
      title={t('privacy_policy')}
    >
      <LegalDocument
        description={t('privacy_document_description', {
          defaultValue: 'Read the policy below for details about information, security, cookies, and your choices.'
        })}
        label={t('privacy_document_label', { defaultValue: 'Your privacy matters' })}
      >
        <p>{t('privacy_policy_para1')}</p>
        <p>{t('privacy_policy_para2')}</p>
        <p>{t('privacy_policy_para3')}</p>

        <p><strong>{t('privacy_policy_heading_info')}</strong></p>
        <p>{t('privacy_policy_info_para1')}</p>
        <ul dir={isRTL ? 'rtl' : 'ltr'}>
          <li>{t('privacy_policy_info_list1')}</li>
          <li>{t('privacy_policy_info_list2')}</li>
          <li>{t('privacy_policy_info_list3')}</li>
          <li>{t('privacy_policy_info_list4')}</li>
        </ul>
        <p>{t('privacy_policy_info_para2')}</p>
        <p>{t('privacy_policy_info_para3')}</p>
        <p>{t('privacy_policy_info_para4')}</p>
        <ul dir={isRTL ? 'rtl' : 'ltr'}>
          <li>{t('privacy_policy_info_list5')}</li>
          <li>{t('privacy_policy_info_list6')}</li>
          <li>{t('privacy_policy_info_list7')}</li>
        </ul>
        <p>{t('privacy_policy_info_para5')}</p>

        <p><strong>{t('privacy_policy_heading_log')}</strong></p>
        <p>{t('privacy_policy_log_para1')}</p>

        <p><strong>{t('privacy_policy_heading_cookie')}</strong></p>
        <p>{t('privacy_policy_cookie_para1')}</p>
        <p>{t('privacy_policy_cookie_para2')}</p>

        <p><strong>{t('privacy_policy_heading_service')}</strong></p>
        <p>{t('privacy_policy_service_para1')}</p>
        <ul dir={isRTL ? 'rtl' : 'ltr'}>
          <li>{t('privacy_policy_service_list1')}</li>
          <li>{t('privacy_policy_service_list2')}</li>
          <li>{t('privacy_policy_service_list3')}</li>
          <li>{t('privacy_policy_service_list4')}</li>
        </ul>
        <p>{t('privacy_policy_service_para2')}</p>

        <p><strong>{t('privacy_policy_heading_security')}</strong></p>
        <p>{t('privacy_policy_security_para1')}</p>

        <p><strong>{t('privacy_policy_heading_link')}</strong></p>
        <p>{t('privacy_policy_link_para1')}</p>

        <p><strong>{t('privacy_policy_heading_children')}</strong></p>
        <p>{t('privacy_policy_children_para1')}</p>

        <p><strong>{t('delete_account_lebel').toUpperCase()}</strong></p>
        <p>{t('delete_account_msg')}</p>
        <p>{t('delete_account_subheading')}</p>
        <ul dir={isRTL ? 'rtl' : 'ltr'}>
          <li>{t('delete_account_para1')}</li>
          <li>{t('delete_account_para2')}</li>
        </ul>

        <p><strong>{t('privacy_policy_heading_change_privacy')}</strong></p>
        <p>{t('privacy_policy_change_privacy_para1')}</p>
        <p>{t('privacy_policy_change_privacy_para2')}</p>

        <p><strong>{t('privacy_policy_heading_contact')}</strong></p>
        <p>
          {t('privacy_policy_contact_para1')}{' '}
          {settings && settings.contact_email ? (
            <a href={`mailto:${settings.contact_email}`}>
              <strong>{settings.contact_email}</strong>
            </a>
          ) : null}
        </p>
      </LegalDocument>
    </PublicPageLayout>
  );
};

export default PrivacyPolicy;
